import { render, staticRenderFns } from "./object-card-list.vue?vue&type=template&id=7f42c35b"
import script from "./object-card-list.vue?vue&type=script&lang=js"
export * from "./object-card-list.vue?vue&type=script&lang=js"
import style0 from "./object-card-list.vue?vue&type=style&index=0&id=7f42c35b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./object-card-list.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports